
import {
    MDBAutocomplete,
    MDBBadge,
    MDBBtn,
    MDBCol,
    MDBIcon,
    MDBInput,
    MDBListGroup,
    MDBListGroupItem,
    MDBRow,
    MDBTabs,
    MDBTabsContent,
    MDBTabsItem,
    MDBTabsLink,
    MDBTabsPane
} from "mdb-react-ui-kit";
import React, { useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { formattedNumber } from "../../views/popups/phonenumbers/AddRemoveNumbers";
import UIConstant from "../../apiclients/UIConstant";
const customDefData3 = [
    { title: 'One', subtitle: 'Secondary text' },
    { title: 'Two', subtitle: 'Secondary text' },
    { title: 'Three', subtitle: 'Secondary text' },
    { title: 'Four', subtitle: 'Secondary text' },
    { title: 'Five', subtitle: 'Secondary text' },
    { title: 'Six', subtitle: 'Secondary text' },
];


function TolllFreePurchasePopupTabs(props) {
console.log("tollAdvancedNumber :: " + props.tollAdvancedNumber)
    const { t, i18n } = useTranslation();
    const [customData3, setCustomData3] = useState(customDefData3);
    const onCustomSearch3 = (value) =>
        setCustomData3(customDefData3.filter((item) => item.title.toLowerCase().startsWith(value.toLowerCase())));

    const [verticalActive, setVerticalActive] = useState('tab1');

    const [centredModal, setCentredModal] = useState(false);
    const toggleOpen = () => setCentredModal(!centredModal);
    const [isButtonClicked, setButtonClicked] = useState(false);
    const [searchValue, setsearchValue] = useState("");
    const [patternValue, setPatternValue] = useState([]);
    const [areacode, setareacode] = useState(-1);
    const [areaerror, setAreaError] = useState('');
    const [vanityerror, setVanityError] = useState('');
    const [addPurchase, setAddPurchase] = useState([]);
    const [showSearchOptions, setShowSearchOptions] = useState(true);
    const [submitFlag, setSubmitFlag] = useState(false);
     const [isConsecutive, setIsConsecutive] = useState(false);
    const [consecutiveCount, setConsecutiveCount] = useState(2);


    const handleVerticalClick = (value) => {
        if (value === verticalActive) {
            return;
        }

        setVerticalActive(value);
        props.setTollAdvancedNumbers([]);
        props.setAdvancedNumbers([]);
        props.setsearchType(0);
    };

    useEffect(() => {
        console.log("are code :::::::: " + props.areacode);
        if (props.areacode != undefined && props.areacode !== "") {
            setareacode(props.areacode);
        }
        if (props.addPurchase && props.addPurchase.length > 0) {
            setAddPurchase(props.addPurchase);

        }
        if (props.errorList && props.submitFlag) {
            if (props.errorList.length > 0) {
                props.errorList.forEach((err) => {
                    if (err.fieldname == 'vanity') {
                        setVanityError(err.message)
                    }
                    if (err.fieldname == 'area_code') {
                        setAreaError(err.message);
                    }
                })
            } else {
                setShowSearchOptions(!showSearchOptions);
            }
            props.setSubmitFlag(false);

        }

    }, [props]);

    const handleSearch = (event) => {
        event.preventDefault();
        if (vanityerror !== "") {
            return;
        }
        console.log()
        const update = {
            reqid: 66,
            siteid: JSON.parse(
                sessionStorage.getItem("admin_session")
            ).siteid,
            vanity: searchValue,
            is_tollfree: true,
            is_consecutive_order:isConsecutive,
            quantity_of_consecutive:consecutiveCount
        }
        console.log("handleVanity :::::::: " + JSON.stringify(update));
        props.oSubmit(update, 4);


        // setShowSearchOptions(!showSearchOptions);


    }

    const handlePattern = (event) => {
        event.preventDefault();
        if (areaerror !== "") {
            return;
        }
        const update = {
            reqid: 66,
            siteid: JSON.parse(
                sessionStorage.getItem("admin_session")
            ).siteid,
            pattern: patternValue,
            area_code: parseInt(areacode),
            is_tollfree: true,
            is_consecutive_order:isConsecutive,
            quantity_of_consecutive:consecutiveCount
        }


        console.log("handlePattern :::::::: " + JSON.stringify(update));
        props.oSubmit(update, 6);
        // setSubmitFlag(true);


        // setShowSearchOptions(!showSearchOptions);



    }

    const patternAdd = (event, postion) => {
        event.preventDefault();
        const position = parseInt(postion);
        if (event.target.value !== "") {
            const value = parseInt(event.target.value)
            const index = patternValue.findIndex(item => item.position === position);
            if (index !== -1) {
                // If position exists, update the value
                const updatedPattern = [...patternValue];
                updatedPattern[index].value = value;
                setPatternValue(updatedPattern);
            } else {
                // If position doesn't exist, add a new object to the array

                const newValue = {
                    position: position,
                    value: value,
                }
                setPatternValue([...patternValue, newValue]);
            }
        } else {
            const updatepattern = patternValue.filter(item => item.position !== position);
            setPatternValue(updatepattern);
        }

        const input = event.target;
        const maxLength = parseInt(input.getAttribute('maxlength'), 10);

        if (input.value.length >= maxLength) {
            focusNextInput(postion);
        }

    }

    function changeAreaCode(e, index) {
        e.preventDefault();
        const input = e.target;
        setareacode(input.value);
        // setAreaError('');
        const maxLength = parseInt(input.getAttribute('maxlength'), 10);

        if (input.value.length >= maxLength) {
            focusNextInput(index);
        }
        const newCode = e.target.value;
        if(newCode.trim()===""){
           setAreaError("Area code is required");
            return;
        }
        const codeIndex = props.tollFreeAreaCodesDisplay.findIndex(item => item.area_code == parseInt(newCode));
        // if ((index === 0 && input.value === "")  ) {
        //     setAreaError('Area code is required');
        //     }
        if (codeIndex === -1 ) {
            setAreaError('Invalid area code');

        } else {
            setAreaError('');
        }
            }

    const [hoverNumber, setHoverNumber] = useState("");

    const handleMouseEnter = (phnum) => {
        setHoverNumber(phnum);

    };

    const handleMouseLeave = () => {
        setHoverNumber("");
    };


    // Create refs for each input field
    const inputRefs = [
        useRef(null),

        useRef(null),
        useRef(null),
        useRef(null),

        useRef(null),
        useRef(null),
        useRef(null),
        useRef(null),
    ];

    // Function to focus on the next input field
    const focusNextInput = index => {
        if (index < inputRefs.length - 1) {
            inputRefs[index + 1].current.focus();
        }
    };

    // Function to focus on the previous input field
    const focusPreviousInput = index => {
        if (index > 0) {
            inputRefs[index - 1].current.focus();
        }
    };


    // Function to handle backspace key press
    const handleBackspace = (e, index) => {
        if (e.keyCode === 8 && e.target.value.length === 0) {
            focusPreviousInput(index);
        }
    };

    const highlightSearchValue = (text, searchPattern, flag) => {
        console.log("Search pattern :::: " + JSON.stringify(searchPattern));
        console.log("Search flag :::: " + flag);

        let highlightedText = text;
        console.log("text :::: " + text);
        if (flag == 6) {
            const sortedSearchpattern = searchPattern.sort((a, b) => b.position - a.position);
            console.log("sortedSearchpattern ::::::::: " + sortedSearchpattern);
            sortedSearchpattern.forEach(({ position, value }) => {
                const pos = parseInt(position) > 3 ? parseInt(position) + 8 : parseInt(position) + 7;
                const digit = text.charAt(pos - 1);
                if (digit === value.toString()) {
                    const before = highlightedText.substring(0, pos - 1);
                    const after = highlightedText.substring(pos);
                    console.log("before ::: " + before);
                    console.log("after ::: " + after);
                    highlightedText = before + '<span class="highlightSearch">' + value + '</span>' + after;
                }
            });
        } else if (flag == 4) {

            const index = text.indexOf(searchPattern);
            let jsonArray = [];
            if (index !== -1) {
                for (let i = 0; i < searchPattern.length; i++) {
                    const position = index + (i + 1);
                    const value = searchPattern[i];
                    jsonArray.push({ position, value });
                }
            }

            const sortedSearchpattern = jsonArray.sort((a, b) => b.position - a.position);
            console.log("sortedSearchpattern ::::::::: " + sortedSearchpattern);
            let formattedNumber = "";
            if (text.length === 10) {
                const countryCode = '+1';
                const areaCode = text.substring(0, 3);
                const exchangeCode = text.substring(3, 6);
                const remainingDigits = text.substring(6);

                // Format the E.164 number
                formattedNumber = `${countryCode} ${areaCode} ${exchangeCode} ${remainingDigits}`;
            } else if (text.length === 11) {
                const countryCode = '+1';
                const areaCode = text.substring(1, 4);
                const exchangeCode = text.substring(4, 7);
                const remainingDigits = text.substring(7);
                formattedNumber = `${countryCode} ${areaCode} ${exchangeCode} ${remainingDigits}`;
            }
            sortedSearchpattern.forEach(({ position, value }) => {
                const posit = parseInt(position);
                const textlength = text.length;
                let pos;
                if (textlength === 11) {
                    pos = posit === 1 ? (posit + 1) : posit > 1 && posit < 5 ? (posit + 2) : posit > 4 && posit < 8 ? (posit + 3) : (posit + 4);

                } else if (textlength === 10) {
                    pos = posit > 0 && posit < 4 ? (posit + 3) : posit > 3 && posit < 7 ? (posit + 4) : (posit + 5);
                }

                const digit = formattedNumber.charAt(pos - 1);
                if (digit === value.toString()) {
                    const before = formattedNumber.substring(0, pos - 1);
                    const after = formattedNumber.substring(pos);
                    console.log("before ::: " + before);
                    console.log("after ::: " + after);
                    formattedNumber = before + '<span class="highlightSearch">' + value + '</span>' + after;
                }
            });
            highlightedText = formattedNumber;
        }
        console.log("highlightedText ::::::: " + highlightedText);

        return highlightedText;
    };

    const handleAddButton = (e, phoneNumber, isSMS, isTollFree,province,lata,api) => {
        e.preventDefault();
        e.stopPropagation();

        const PhIndex = addPurchase.findIndex(number => number.phone_number === phoneNumber);
        let updatedNumbers;
        if (PhIndex === -1) {
            let number = {
                phone_number: phoneNumber,
                is_sms_enabled: isSMS,
                is_toll_free: isTollFree,
                province: province,
                lata :lata,
                api : api ? api : false
            }

            updatedNumbers = [...addPurchase, number];
        } else {
            updatedNumbers = addPurchase.filter(number => number.phone_number !== phoneNumber);
        }
        setAddPurchase(updatedNumbers);
        props.setAddPurchase(updatedNumbers);

    };


    // Function to clear all input values
    const clearInputValues = () => {
        inputRefs.forEach((ref, index) => {
             if(index === 0) {
            ref.current.value = props.exitingTollFreeAreaCode ? props.exitingTollFreeAreaCode : ''; // Clear the value of each input field
            } else {
            ref.current.value = ''; // Clear the value of each input field
            }
        });
        setareacode(props.exitingTollFreeAreaCode)
        setAreaError("")
        setIsConsecutive(false);
        setConsecutiveCount(2);
    };


    return (
        <>
            {showSearchOptions && (
                <>

                    <div className="d-flex justify-content-between align-items-center pb-3">
                        <div className="general-settings">Advanced Search</div>
                        <MDBBtn onClick={props.toggleAdvancedSearch} color="light">
                            <MDBIcon fas icon="times" className="fs-5" />
                        </MDBBtn>
                    </div>
                    <MDBTabs className='pb-3'>
                        <MDBTabsItem>
                            <MDBTabsLink onClick={() => handleVerticalClick('tab1')} active={verticalActive === 'tab1'}>
                                Vanity
                            </MDBTabsLink>
                        </MDBTabsItem>
                        <MDBTabsItem>
                            <MDBTabsLink onClick={() => handleVerticalClick('tab2')} active={verticalActive === 'tab2'}>
                                Pattern
                            </MDBTabsLink>
                        </MDBTabsItem>
                    </MDBTabs>
                    {/* </MDBCol> */}
                    {/* <MDBCol size='9' className="acc-body"> */}
                    <MDBTabsContent className="h-100">
                        <MDBTabsPane open={verticalActive === 'tab1'}>
                            <div>
                                <div className="d-flex align-items-start justify-content-between pb-3">
                                    <div className="tel-numbers d-flex flex-column ">
                                        <b>
                                            {t("Vanityphrase")}
                                        </b>
                                        <span className="text-secondary text-small">
                                            To choose placement, use pattern search
                                        </span>
                                    </div>


                                    <div className="phoneselect w-40 mt-2">

                                        <div className="form-outline">
                                            <input type="text" className="form-control" value={searchValue} onChange={(e) => {
                                                if (e.target.value.length > 7) {
                                                    setVanityError("Maximum 7 characters allowed");
                                                } else if (e.target.value.toString().startsWith("0")){
                                                    setVanityError("Should not start with zero");
                                                } else if (e.target.value.length > 0 && e.target.value.length < 4) {
                                                    setVanityError("Minimum 4 characters");
                                                } else {
                                                    setVanityError("");
                                                }
                                                setsearchValue(e.target.value.toUpperCase());
                                            }} placeholder='E.g. "Bus","1234"'
                                            />
                                            {vanityerror && <div style={{ color: 'red' }}>{vanityerror}</div>}
                                        </div>
                                    </div>
                                </div>
                                <div className="add-numbermain noHoverBg m-0 px-0">
                                    <p className="me-2">Request multiple phone numbers in consecutive order</p>
                                    <label className="switch">
                                        <input
                                            className="form-control"
                                            type="checkbox"
                                            checked={isConsecutive}
                                            onChange={(e) => setIsConsecutive(!isConsecutive)}
                                        />
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                                {isConsecutive &&
                                    <>
                                        <div className="add-numbermain noHoverBg m-0 px-0">
                                            <div className="tel-numbers">
                                                Quantity of consecutive numbers (max: {UIConstant.MAX__CONSECUTIVE_NUMBERS}) <br />
                                                <span className="phrecording text-secondary">
                                                    Only show numbers grouped in this minimum quantity
                                                </span>
                                            </div>

                                            <div className="d-flex align-items-center justify-content-center">
                                                <div className="d-flex align-items-center border rounded" style={{ width: "120px", justifyContent: "space-between" }}>
                                                    <MDBBtn size="sm" color="light"
                                                        disabled={consecutiveCount <= 2}
                                                        onClick={() => {
                                                            setConsecutiveCount((prev) => Math.max(prev - 1, 2));
                                                        }}
                                                    >
                                                    <MDBIcon fas icon="minus" />

                                                    </MDBBtn>
                                                    <span>{consecutiveCount}</span>
                                                    <MDBBtn size="sm" color="light"
                                                        disabled={consecutiveCount >= UIConstant.MAX__CONSECUTIVE_NUMBERS}
                                                        onClick={() => {
                                                            setConsecutiveCount((prev) => Math.min(prev + 1, UIConstant.MAX__CONSECUTIVE_NUMBERS));
                                                        }}
                                                    >
                                                    <MDBIcon fas icon="plus" />

                                                    </MDBBtn>
                                                </div>
                                            </div>
                                        </div>
                                    </>
                                }
                                <div className="d-flex py-2 justify-content-between">
                                    <MDBBtn color="secondary" onClick={(e) => {
                                        e.preventDefault();
                                        setsearchValue("");
                                        setIsConsecutive(false);
                                        setConsecutiveCount(2);
                                    }}>Reset</MDBBtn>
                                    <div>
                                        <MDBBtn className="me-2" color="secondary" onClick={props.toggleAdvancedSearch}>Cancel</MDBBtn>
                                        <a href="#SearchResultsPattern">
                                            <MDBBtn onClick={(e) => handleSearch(e)}>Search</MDBBtn>
                                        </a>
                                    </div>
                                </div>

                            </div>
                            
                        </MDBTabsPane>
                        <MDBTabsPane open={verticalActive === 'tab2'}>



                            <div className="tel-numbers">
                                <b>
                                    {t("Patternsearch")}
                                </b>
                                <br />
                                <span className="phrecording">
                                    Enter any combination of numbers or letters (regional code is required)
                                </span>

                                <div className="d-flex align-items-start my-3">
                                    <div className="me-2 w-50">
                                        <MDBInput
                                            placeholder={areacode}
                                            type="text"
                                            className="text-center"
                                            maxLength={3}
                                            ref={inputRefs[0]}
                                            value={areacode}
                                            onChange={e => changeAreaCode(e, 0)}
                                            onKeyDown={e => handleBackspace(e, 0)}
                                        />
                                        {areaerror && <div style={{ color: 'red' }}>{areaerror}</div>}
                                    </div>
                                    <span className="me-2 mt-2">-</span>
                                    {inputRefs.slice(1).map((ref, index) => (
                                        <>
                                            {index === 3 && (
                                                <span className="me-2 mt-2">-</span>
                                            )}
                                            <div key={index} className="me-2">
                                                <MDBInput
                                                    placeholder="*"
                                                    type="text"
                                                    className="text-center"
                                                    maxLength={1}
                                                    ref={ref}
                                                    onKeyPress={(event) => {
                                                        if (!/[0-9]/.test(event.key)) {
                                                            event.preventDefault();
                                                        }
                                                    }}
                                                    onChange={e => patternAdd(e, index + 1)}
                                                    onKeyDown={e => handleBackspace(e, index + 1)}
                                                />
                                            </div>
                                        </>
                                    ))}
                                </div>


                                <span className="phrecording d-block" >
                                    <b>
                                        Pattern Search Instructions:
                                    </b>
                                    <ol>
                                        <li>
                                            Enter any combination of numbers or letters in the available boxes.
                                        </li>
                                        <li>
                                            You don't have to fill out all the boxes.
                                        </li>
                                        <li>
                                        For the best results, fill out as few boxes as possible.
                                        </li>
                                    </ol>
                                </span>
                            </div>
                            <div className="add-numbermain noHoverBg m-0 px-0">
                                    <p className="me-2">Request multiple phone numbers in consecutive order</p>
                                    <label className="switch">
                                        <input
                                            className="form-control"
                                            type="checkbox"
                                            checked={isConsecutive}
                                            onChange={(e) => setIsConsecutive(!isConsecutive)}
                                        />
                                        <span className="slider round"></span>
                                    </label>
                                </div>
                            {isConsecutive &&
                                <>
                                    <div className="add-numbermain noHoverBg m-0 px-0">
                                        <div className="tel-numbers">
                                            Quantity of consecutive numbers (max: {UIConstant.MAX__CONSECUTIVE_NUMBERS}) <br />
                                            <span className="phrecording text-secondary">
                                                Only show numbers grouped in this minimum quantity
                                            </span>
                                        </div>

                                        <div className="d-flex align-items-center justify-content-center">
                                            <div className="d-flex align-items-center border rounded" style={{ width: "120px", justifyContent: "space-between" }}>
                                                <MDBBtn size="sm" color="light"
                                                    disabled={consecutiveCount <= 2}
                                                    onClick={() => {
                                                        setConsecutiveCount((prev) => Math.max(prev - 1, 2));
                                                    }}
                                                >
                                                <MDBIcon fas icon="minus" />
                                                </MDBBtn>
                                                <span>{consecutiveCount}</span>
                                                <MDBBtn size="sm" color="light"
                                                    disabled={consecutiveCount >= UIConstant.MAX__CONSECUTIVE_NUMBERS}
                                                    onClick={() => {
                                                        setConsecutiveCount((prev) => Math.min(prev + 1, UIConstant.MAX__CONSECUTIVE_NUMBERS));
                                                    }}
                                                >
                                                <MDBIcon fas icon="plus" />

                                                </MDBBtn>
                                            </div>
                                        </div>
                                    </div>
                                </>
                            }
                            <div className="d-flex py-2 justify-content-between">
                                <MDBBtn color="secondary" onClick={clearInputValues}>Reset</MDBBtn>
                                <div>
                                    <MDBBtn className="me-2" color="secondary" onClick={props.toggleAdvancedSearch}>Cancel</MDBBtn>
                                    <MDBBtn onClick={handlePattern}>Search</MDBBtn>
                                </div>
                            </div>

                        </MDBTabsPane>
                    </MDBTabsContent>
                </>
            )}

            {!showSearchOptions &&
                <div>
                    <div className="d-flex justify-content-between align-items-center">
                        <div className="d-flex">
                            <MDBBtn onClick={props.searchType === 4 ? handleSearch : handlePattern} color="light" className="me-3">
                                <MDBIcon fas icon="arrow-left" className="fs-5" />
                            </MDBBtn>
                            <div className="general-settings">Results</div>
                        </div>
                        <MDBBtn onClick={props.toggleAdvancedSearch} color="light">
                            <MDBIcon fas icon="times" className="fs-5" />
                        </MDBBtn>
                    </div>
                    <div>


                        <div>
                            <MDBListGroup light className="list-view h-30">
                                {props.tollAdvancedNumber.length > 50 && (
                                    <p>
                                        50 numbers of many
                                    </p>
                                )}

                                {props.tollAdvancedNumber && props.tollAdvancedNumber.length > 0 ? (
                                    props.tollAdvancedNumber.map(result => (
                                        <MDBListGroupItem key={result.phone_number} className='d-flex justify-content-between align-items-center'>
                                            <div className="d-flex align-items-center">
                                                <div>
                                                    <div className="d-flex align-items-center">
                                                        <div dangerouslySetInnerHTML={{ __html: highlightSearchValue((props.searchType === 4 ? result.display_phone_number : formattedNumber(result.phone_number)), props.advacedSearchType, props.searchType) }} />
                                                        {result.is_sms_enabled === 1 && (
                                                            <MDBBadge color="primary" title="SMS Capable" className="fw-400"><MDBIcon far icon="comment-alt" /></MDBBadge>
                                                        )}
                                                    </div>
                                                    {/* <div className='text-muted'>Debary, FL</div> */}
                                                </div>
                                            </div>
                                            <MDBBtn
                                                size="sm"
                                                color={addPurchase.some(item => item.phone_number === result.phone_number) ? (hoverNumber === result.phone_number ? 'danger' : 'success') : 'primary'}
                                                onClick={(e) => handleAddButton(e, result.phone_number, result.is_sms_enabled, true,result.province,result.lata,result?.api ?? false)}
                                                onMouseEnter={() => handleMouseEnter(result.phone_number)} // Call the function
                                                onMouseLeave={() => handleMouseLeave()} // Call the function
                                                className="shadow-0"
                                            >
                                                <MDBIcon
                                                    fas
                                                    icon={addPurchase.some(item => item.phone_number === result.phone_number) ? (hoverNumber === result.phone_number ? 'times' : 'check') : 'plus'}
                                                    color="white"
                                                    style={{ fontSize: 10 }}
                                                />
                                                <span className={addPurchase.some(item => item.phone_number === result.phone_number) ? `ms-2 text-light w-40px` : `ms-2 text-light`} style={{ fontSize: 11, width: "50px" }}>
                                                    {addPurchase.some(item => item.phone_number === result.phone_number) ? (hoverNumber === result.phone_number ? 'Remove' : 'Added') : 'Add'}
                                                </span>
                                            </MDBBtn>
                                        </MDBListGroupItem>
                                    ))
                                ) : (
                                    <div>
                                        No Records found
                                    </div>
                                )}
                            </MDBListGroup>
                        </div>
                    </div>
                </div>
            }
        </>
    )
}
export default TolllFreePurchasePopupTabs